// Sistema de ícones único - elimina importações duplicadas
import {
  Target,
  FileText,
  TrendingUp,
  PiggyBank,
  Settings,
  Wallet,
  User,
  ArrowUpCircle,
  ArrowDownCircle,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Plus,
  Edit,
  Trash2,
  Copy,
  MoreVertical,
  Calendar,
  AlertTriangle,
  Save,
  ArrowLeft,
  Loader2,
  Check,
  Building2
} from "lucide-react";

// Mapa único de ícones - evita duplicação de imports
export const ICONS = {
  Target,
  FileText,
  TrendingUp,
  PiggyBank,
  Settings,
  Wallet,
  User,
  ArrowUpCircle,
  ArrowDownCircle,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Plus,
  Edit,
  Trash2,
  Copy,
  MoreVertical,
  Calendar,
  AlertTriangle,
  Save,
  ArrowLeft,
  Loader2,
  Check,
  Building2
};

// Função para obter ícone - centralizada
export const getIcon = (iconName) => ICONS[iconName] || ICONS.FileText;

// HOC para componentes com ícone
export const withIcon = (iconName, className = "w-5 h-5") => {
  const IconComponent = getIcon(iconName);
  return <IconComponent className={className} />;
};
